import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CheckCircleIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="m10.55 15.7 6.2-6.2-.5-.5-5.7 5.7-2.85-2.85-.5.5 3.35 3.35Zm1.454 5a8.482 8.482 0 0 1-3.393-.685 8.79 8.79 0 0 1-2.764-1.858 8.78 8.78 0 0 1-1.861-2.761 8.458 8.458 0 0 1-.686-3.392c0-1.203.228-2.334.685-3.393a8.79 8.79 0 0 1 1.858-2.764 8.78 8.78 0 0 1 2.761-1.861 8.458 8.458 0 0 1 3.392-.686c1.203 0 2.334.228 3.393.685a8.79 8.79 0 0 1 2.764 1.858 8.779 8.779 0 0 1 1.861 2.761 8.457 8.457 0 0 1 .686 3.392 8.482 8.482 0 0 1-.685 3.393 8.79 8.79 0 0 1-1.858 2.764 8.779 8.779 0 0 1-2.761 1.861 8.457 8.457 0 0 1-3.392.686ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
            />
        </svg>
    </IconWrapper>
));
